module.exports = __webpack_public_path__ + "static/media/Card-Abstract.27f13f9b.svg";